import { supabase } from "@/integrations/supabase/client";
import { getSessionId } from "@/lib/session";
import { recordReferralVisit, claimReferralRegistration } from "@/lib/viralReferral.functions";

const STORAGE_KEY = "vs:viral_ref_token";

function readUrlRef(): string | null {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  const ref = params.get("ref");
  if (!ref) return null;
  if (!/^[A-Z0-9]{6,32}$/.test(ref)) return null;
  return ref;
}

/** Call once at app boot (root layout). Captures ?ref= and records a visit. */
export function initViralCapture(): void {
  if (typeof window === "undefined") return;
  const ref = readUrlRef();
  if (!ref) return;
  const existing = localStorage.getItem(STORAGE_KEY);
  if (existing === ref) return;
  localStorage.setItem(STORAGE_KEY, ref);
  const session_id = getSessionId();
  void recordReferralVisit({ data: { token: ref, session_id } }).catch(() => {});
}

/** Call after successful sign-up / sign-in to attribute the conversion. */
export async function attributePendingReferral(): Promise<void> {
  if (typeof window === "undefined") return;
  const token = localStorage.getItem(STORAGE_KEY);
  if (!token) return;
  const { data } = await supabase.auth.getUser();
  if (!data.user) return;
  const session_id = getSessionId();
  try {
    await claimReferralRegistration({ data: { token, session_id } });
    localStorage.removeItem(STORAGE_KEY);
  } catch { /* keep token for retry */ }
}